<script lang="ts" setup>
const form = ref<HTMLFormElement>()

function submit(): void {
  form.value?.submit()
}
</script>

<template>
  <form id="donate-button-form" ref="form" action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_blank">
    <input type="hidden" name="cmd" value="_donations">
    <input type="hidden" name="business" value="mail@ongehoord.info">
    <input type="hidden" name="item_name" value="Donations">
    <input type="hidden" name="currency_code" value="EUR">
    <DonateContentButton icon="cib:paypal" label="Doneren via PayPal" block @click="submit()" />
  </form>
</template>
